import { render, staticRenderFns } from "./cancerVariation.vue?vue&type=template&id=d9d6731a&scoped=true"
import script from "./cancerVariation.vue?vue&type=script&lang=js"
export * from "./cancerVariation.vue?vue&type=script&lang=js"
import style0 from "./cancerVariation.vue?vue&type=style&index=0&id=d9d6731a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d6731a",
  null
  
)

export default component.exports